module.exports = __webpack_public_path__ + "static/img/pdf-logo.9469ce60.png";